import { apiRequest } from '../../../lib/api';
import { API_PATHS } from '../../../lib/apiRoutes';
import { buildStickyIdempotencyKey } from '../../../lib/idempotency';
import type { ReferralSummary } from '../types/referrals.types';

interface ReferralEnvelope {
  data: ReferralSummary;
}

/** Signup link parameter carrying a friend's referral code, e.g. `/signup?ref=NINPO-ABC234`. */
export const REFERRAL_QUERY_PARAM = 'ref';

export const referralsApi = {
  async getMine(): Promise<ReferralSummary> {
    const payload = await apiRequest<ReferralEnvelope>(API_PATHS.referrals.me);
    return payload.data;
  },
  async claim(code: string): Promise<ReferralSummary> {
    const payload = await apiRequest<ReferralEnvelope>(API_PATHS.referrals.claim, {
      method: 'POST',
      body: JSON.stringify({ code: code.trim().toUpperCase() }),
      idempotencyKey: buildStickyIdempotencyKey('referral-claim', [code.trim().toUpperCase()]),
      requireIdempotencyKey: true
    });
    return payload.data;
  }
};
